import { render, staticRenderFns } from "./CrmView.vue?vue&type=template&id=79669f28"
import script from "./CrmView.vue?vue&type=script&lang=js"
export * from "./CrmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports